import NextLink from 'next/link'
import { type FC } from 'react'

import { type PimProductV1Rating } from '@redteclab/api/clients/bully'

import { Link, Rating } from 'base-ui'

import { TosSuperscriptHowProductRatingCalculated } from '../../../tos-superscripts/ components/TosSuperscriptHowProductRatingCalculated'

export const ExperimentOwnBrandsProductRating: FC<{
  href: string
  rating: PimProductV1Rating
}> = ({ href, rating }) => (
  <div className="flex">
    <Link<typeof NextLink>
      className="shrink-0"
      data-qa-id="product-rating"
      href={href}
      slots={{ root: NextLink }}
    >
      <Rating
        className="align-middle text-l"
        readOnly
        slotProps={{
          iconContainer: {
            className: '-mx-0.5',
          },
        }}
        value={rating.average}
      />
      <TosSuperscriptHowProductRatingCalculated className="top-1 ml-1" />
    </Link>
    <Link<typeof NextLink>
      className="pl-1 no-underline"
      color="inherit"
      data-qa-id="product-rating"
      href={href}
      slots={{ root: NextLink }}
    >{`(${rating.count})`}</Link>
  </div>
)
